(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      /* rg 2026-07-27: these drive the hysteresis in onScroll but were left
         undefined until the first direction change. */
      this.scrollDirection = 0;
      this.directionBuffer = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      /* rg 2026-07-25: coalesce to one onScroll per rendered frame. iOS fires
         several scroll events per frame; running the handler (and its
         classList writes) for each one is wasted main-thread work exactly when
         scrolling needs it most. */
      this._ticking = false;
      this.onScrollHandler = () => {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => { this._ticking = false; this.onScroll(); });
      };
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      /* rg-perf 2026-07-18: passive. onScroll never calls preventDefault (verified),
         so a non-passive listener only forced the compositor to wait on JS before
         it could scroll. Behaviour unchanged. */
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      /* rg 2026-07-28: the async IntersectionObserver that used to seed
         headerBounds here is gone. Until it fired, headerBounds was {} and
         every gate in onScroll compared against undefined: the
         not-yet-past-the-header early return never triggered and reset() was
         unreachable, so a scroll begun during first-paint jank (all app
         scripts booting) could hide() the header while it was still on
         screen, from the static state -- i.e. with no transition. Frame
         analysis of a 60fps recording (Jul 28) caught exactly that. Bounds
         are now computed synchronously at connect via _syncBounds below;
         there is no window in which they do not exist. */
      /* rg 2026-07-27: recompute from document coordinates on resize, so
         anything that changes header height afterwards (orientation change,
         late app block, a section above the header being enabled/disabled)
         cannot leave the hide/reveal thresholds pointing at stale pixel
         values. iOS URL-bar-only height changes fire resize without any real
         layout change and are ignored. */
      this._lastViewportWidth = window.innerWidth;
      this._syncBounds = () => {
        const rect = this.header.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        this.headerBounds = { top: top, bottom: top + rect.height };
        this.setHeaderHeight();
      };
      this._syncBounds();
      window.addEventListener('resize', () => {
        if (window.innerWidth === this._lastViewportWidth) return;
        this._lastViewportWidth = window.innerWidth;
        clearTimeout(this._resizeT);
        this._resizeT = setTimeout(this._syncBounds, 150);
      }, { passive: true });
      window.addEventListener('orientationchange', () => {
        clearTimeout(this._resizeT);
        this._resizeT = setTimeout(this._syncBounds, 300);
      }, { passive: true });
    }

    onScroll() {
      /* rg 2026-07-27: iOS reports negative scroll offsets at the top and
         past-max offsets at the bottom while rubber-banding (see w3c/csswg-drafts
         #4011 -- Apple keeps firing scroll events with out-of-range offsets and
         notes that content doing math on them "jiggles"). Clamping kills the
         phantom direction flips those produce at both ends of the page. */
      const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const rawScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollTop = Math.min(Math.max(rawScrollTop, 0), maxScroll);

      /* rg 2026-07-28: self-heal. If bounds are ever non-numeric (theme
         editor re-mount, exotic lifecycle), recompute before any gate below
         compares against them -- comparisons against undefined disable the
         entire state machine silently. */
      if (!(this.headerBounds && this.headerBounds.bottom >= 0)) this._syncBounds();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const delta = scrollTop - this.currentScrollTop;
      this.currentScrollTop = scrollTop;

      if (scrollTop <= this.headerBounds.top) {
        /* rg 2026-07-25: on a fast fling to the top, iOS elastic bounce swings
           scrollTop back and forth across this boundary; resetting per event and
           re-revealing on the next one replayed the appear-down animation each
           crossing = the "header flashes when I scroll up fast" bug. Only reset
           after the position has stayed at the top for 120ms; bounce spikes
           cancel the pending reset and the header simply stays revealed. */
        window.clearTimeout(this._topResetT);
        this._topResetT = setTimeout(() => {
          this.header.classList.remove('scrolled-past-header');
          this.scrollDirection = 0;
          this.directionBuffer = 0;
          this.reset();
        }, 120);
        return;
      }
      window.clearTimeout(this._topResetT);

      if (scrollTop <= this.headerBounds.bottom) return;

      this.header.classList.add('scrolled-past-header');

      /* rg 2026-07-23: direction hysteresis. The stock per-event comparison
         flipped hide/reveal on every 1-2px counter-movement (iOS momentum +
         URL-bar jitter), strobing the header on mobile scroll-up. A direction
         change now requires 10px of accumulated movement before taking effect.
         Verified in isolation: 17 hide/reveal flips under jitter -> 1. */
      const dir = delta > 0 ? 1 : delta < 0 ? -1 : 0;
      if (dir === 0) return;
      if (dir === this.scrollDirection) {
        this.directionBuffer = 0;
      } else {
        this.directionBuffer = (this.directionBuffer || 0) + Math.abs(delta);
        if (this.directionBuffer < 10) return;
        this.scrollDirection = dir;
        this.directionBuffer = 0;
      }

      if (this.scrollDirection === 1) {
        if (this.preventHide) return;
        this.hide();
      } else {
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      /* rg 2026-07-27 (v2): animate the hide ONLY when the header is currently
         pinned AND visible.

         Why the condition matters. `shopify-section-header-sticky` is
         `position:sticky;top:0`. Adding it while the user has already scrolled
         the header off-screen PINS the header back to the top of the viewport
         -- it reappears. In v1 this frame was followed by an animated 180ms
         slide-out, so the header visibly popped in and then slid away. Frame
         analysis of a 60fps screen recording caught it twice: the top band goes
         dark (header gone, ~123 luma) then jumps back to ~242 for 3-4 frames
         before sliding out again.

         So: coming from the reset/static state the header is off-screen, and
         the hidden transform must apply in the SAME style pass as the sticky
         pin, with no transition -- nothing is on screen to animate, and the pop
         never renders. Coming from a revealed+pinned state the header IS on
         screen, and the slide-out is what the user should see. */
      var cl = this.header.classList;
      var pinnedAndVisible = cl.contains('shopify-section-header-sticky')
                          && !cl.contains('shopify-section-header-hidden');
      if (pinnedAndVisible) {
        cl.add('animate');
      } else {
        cl.remove('animate');
      }
      cl.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      /* rg 2026-07-27: header variants without a search modal made every hide()
         throw here, which aborted the rest of the hide path. */
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
